import React, { useContext, useEffect, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { UserContext } from '../userContext/UserContext';
import './logout.css';

const Logout = () => {
    const { instance } = useMsal();
    const { resetAuth } = useContext(UserContext);
    const logoutStarted = useRef(false);

    useEffect(() => {
        if (logoutStarted.current) return;
        logoutStarted.current = true;

        const performLogout = async () => {
            resetAuth();

            try {
                await instance.logoutRedirect({
                    postLogoutRedirectUri: 'https://oil.spm-automation.com/signin',
                });
            } catch (error) {
                console.error('logoutRedirect failed, falling back to manual redirect:', error);
                window.location.href = '/signin';
            }
        };

        performLogout();
    }, [instance, resetAuth]);

    return <div className='logout'>Logging out...</div>;
};

export default Logout;
